import { Injectable } from '@angular/core';
import packageInfo from '../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private readonly version: string;
  private readonly gitHash: string;

  constructor() {
    this.version = packageInfo.version;
    this.gitHash = packageInfo.ch_pixelverse.gitHash;
    console.log(`Version: ${this.version} (${this.gitHash})`);
  }

  appVersion(): string {
    return `${this.version} (${this.gitHash})`;
  }
}
